export const TENANT = window.location.hostname.split('.')[0];
